export const CreditCard = {
  Title: {
    CreditCardInfo: 'クレジットカード情報',
    CreditCardRegist: 'クレジットカード登録',
    CreditCardRegistComplete: 'クレジットカード登録完了',
  },
  Item: {
    CardNo: 'カード番号',
    CardholderName: 'カード名義人',
    CardExpirationDate: 'カード有効期限',
    CardBrand: 'カードブランド',
    SecurityCode: 'セキュリティコード',
    CardExpMonth: 'カード有効期限（月）',
    CardExpYear: 'カード有効期限（年）',
  },
  CardBrandMessage:
    'クレジットカードブランドは、Visa、MasterCard、JCB、American Express、Diners Clubがご利用いただけます。',
  Message: {
    CannotDeleted:
      '※未完了の予約があるので、クレジットカードを削除できません。',
    ReRegister: '※クレジットカード情報の再登録をお願いします。',
    NoCardInfo: '※カード情報未登録です。',
    RegisterOneCard:
      'クレジットカードの登録は一枚のみとなります。\n新しいカードを追加すると、以前のカード情報が更新されます。',
    RegistComplete: 'クレジットカードの登録が完了しました。',
  },
  Button: {
    ResistUpdate: 'クレジットカード登録・更新',
    Delete: 'クレジットカード削除',
    Info: 'クレジットカード情報',
  },
  SelectItem: {
    Year: '年',
    Month: '月',
  },
  DeleteDialog: {
    Title: 'クレジットカードを削除します。よろしいですか？',
    OkButton: '削除する',
    CancelButton: '戻る',
  },
  Validation: {
    InvalidNumberOnly: '半角数字のみで入力してください。',
    InvalidAlphaNumericSymbolsOnly:
      '{0}文字から{1}文字以内の半角英数記号で入力してください。',
  },
};
